module.exports = __webpack_public_path__ + "static/media/Lafayette Cam 12-mobile.33e3cb41.webp";